// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/StaffStats.js
import React from 'react';
import { Users, UserCheck, UserX, Fingerprint, Check, Loader2 } from 'lucide-react';

const StaffStats = ({
  staff = [],
  staffCount,
  activeCount,
  disabledCount,
  prefix,
  prefixSet,
  onPrefixChange,
  onSetPrefix,
  isProcessing
}) => (
  /* Mobile-First Grid System: Stacked on mobile, 2 columns on tablet, 4 columns on desktop */
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    
    {/* Card 1: Total Staff Counter */}
    <div className="bg-white border border-slate-200/80 rounded-xl p-4 shadow-xs">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-xl bg-slate-50 border border-slate-100 text-slate-600 shrink-0">
          <Users size={18} />
        </div>
        <div className="min-w-0 leading-tight">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Total Staff</p>
          <p className="text-xl font-black text-slate-900 mt-0.5">{staffCount}</p>
        </div>
      </div>
    </div>

    {/* Card 2: Active Staff Counter */}
    <div className="bg-white border border-slate-200/80 rounded-xl p-4 shadow-xs">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-xl bg-emerald-50/50 border border-emerald-100 text-emerald-600 shrink-0">
          <UserCheck size={18} />
        </div>
        <div className="min-w-0 leading-tight">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Active</p>
          <p className="text-xl font-black text-emerald-600 mt-0.5">{activeCount}</p>
        </div>
      </div>
    </div>

    {/* Card 3: Disabled Staff Counter */}
    <div className="bg-white border border-slate-200/80 rounded-xl p-4 shadow-xs">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-xl bg-slate-100/80 border border-slate-200/60 text-slate-500 shrink-0">
          <UserX size={18} />
        </div>
        <div className="min-w-0 leading-tight">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Disabled</p>
          <p className="text-xl font-black text-slate-700 mt-0.5">{disabledCount}</p>
        </div>
      </div>
    </div>

    {/* Card 4: Functional Staff Prefix Widget Layer */}
    <div className="bg-white border border-slate-200/80 rounded-xl p-4 shadow-xs flex flex-col justify-center min-h-[74px]">
      <div className="flex items-center justify-between gap-2 w-full">
        <div className="min-w-0 leading-none">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider flex items-center gap-1">
            <Fingerprint size={12} className="text-slate-300 shrink-0" />
            <span>ID Prefix</span>
          </p>
        </div>

        {prefixSet ? (
          /* Locked Dynamic State Badge */
          <div className="flex items-center gap-1.5 shrink-0">
            <span className="text-xs font-black font-mono text-slate-900 bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md tracking-wider">
              {prefix}
            </span>
            <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-wide flex items-center gap-0.5">
              <Check size={12} strokeWidth={3} />
              <span>Active</span>
            </span>
          </div>
        ) : (
          /* Operational Parameter Modification Input Cluster Row */
          <div className="flex items-center gap-1 shrink-0 max-w-[65%]">
            <input
              type="text"
              value={prefix || ''}
              onChange={(e) => onPrefixChange(e.target.value.toUpperCase())}
              placeholder="ABCD"
              className="w-16 h-8 px-2 border border-slate-200 text-xs text-center font-bold font-mono uppercase rounded-lg outline-hidden focus:bg-white focus:ring-1 focus:ring-slate-900 focus:border-slate-900 placeholder-slate-300"
              maxLength={4}
              pattern="[A-Z]*"
              disabled={isProcessing}
            />
            <button 
              type="button"
              onClick={onSetPrefix}
              disabled={!prefix || isProcessing}
              className={`h-8 px-3 rounded-lg text-xs font-bold transition-all flex items-center justify-center min-w-[42px] ${
                !prefix || isProcessing
                  ? 'bg-slate-100 text-slate-400 border border-slate-200/60 cursor-not-allowed'
                  : 'bg-slate-900 hover:bg-slate-800 text-white shadow-xs active:scale-95'
              }`}
            >
              {isProcessing ? <Loader2 size={12} className="animate-spin text-slate-400" /> : 'Set'}
            </button>
          </div>
        )}
      </div>
    </div>

  </div>
);

export default StaffStats;